import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class PackingMaterialSizeMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      tableStatus: "",
      isLoading: false,
      packingMaterialList: [],
      packingMaterialDetails: {
        packingMaterialSize: "",
      },
    };
  }

  componentDidMount() {
    this.getAllPackingMaterialSize();
  }

  getAllPackingMaterialSize = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllPackingMaterialSize().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { packingMaterialList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  addEditPackingMaterialSize = () => {
    if (this.state.packingMaterialDetails.packingMaterialSize !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.packingMaterialDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices
          .addEditPackingMaterialSize(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              this.resetForm();
              this.SwalServices.Success(response.Message);
              this.setState({ isLoading: false })
            } else {
              this.SwalServices.Error(
                response.Message
              );
              this.setState({ isLoading: false })
            }
          });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.packingMaterialDetails;
    details.packingMaterialSize = "";
    this.setState({ packingMaterialDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllPackingMaterialSize();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.packingMaterialDetails;
    details[name] = value.toUpperCase();
    this.setState({ packingMaterialDetails: details });
  };

  getPackingMaterialById = (group) => {
    let details = this.state.packingMaterialDetails;
    details.packingMaterialSize = group.packingMaterialSize;
    this.setState({ packingMaterialDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deletePackingMaterialSizeById = (id) => {
    this.itemMasterServices
      .deletePackingMaterialSizeById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          this.SwalServices.Success(response.Message);
          this.resetForm();
          this.getAllPackingMaterialSize();
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp !gap-0 w-[50%] !mb-3.5">
              <label>Packing Material Size</label>
              <input
                className="inputFocus"
                type="text"
                id="packingMaterialSize"
                name="packingMaterialSize"
                value={this.state.packingMaterialDetails.packingMaterialSize}
                onChange={(event) =>
                  this.handleChange(event, "packingMaterialSize")
                }
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditPackingMaterialSize()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditPackingMaterialSize()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()} disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '85%' }}>Packing Material</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.packingMaterialList &&
                    this.state.packingMaterialList.length > 0 ?
                    this.state.packingMaterialList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.packingMaterialSize}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getPackingMaterialById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() =>
                              this.deletePackingMaterialSizeById(group._id)
                            }
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.packingMaterialList &&
                      this.state.packingMaterialList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.packingMaterialList &&
                      this.state.packingMaterialList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PackingMaterialSizeMaster;
